/* eslint-disable no-restricted-syntax */
import Store from '../configureStore';
import { gamification, interactions, discovery } from '../redux/actions';
import { log } from './iframeHelper';

const { store } = Store;
const { dispatch } = store;

const dispatcher = {
  rfQuiz: (didPassTheQuiz) => dispatch(gamification.setPassedRfQuiz(didPassTheQuiz)),
  mumQuiz: (didPassTheQuiz) => dispatch(gamification.setPassedMmQuiz(didPassTheQuiz)),
  lmQuiz: (didPassTheQuiz) => dispatch(gamification.setPassedLmQuiz(didPassTheQuiz)),
};

/**
 * Set quiz is done in gamification object
 *
 * @param {string} type Either rfQuiz or mumQuiz
 */
export const setIsQuizDone = (type, canGetLMBadge = false) => {
  let didPassTheQuiz;

  if (type === 'lmQuiz') {
    didPassTheQuiz = canGetLMBadge;
  } else {
    const quizState = store.getState().quiz.quizState[type] || null;
    const quiz = store.getState().quiz[type] || null;

    if (!Object.keys(quizState).length) return false;
    const totalQuizes = quiz.length;
    const totalPasses = Object.keys(quizState)
      .map((key) => quizState[key])
      .filter(({ passed }) => passed)
      .length;
    didPassTheQuiz = totalQuizes === totalPasses || (totalQuizes - 1) === totalPasses;
  }

  dispatcher[type](didPassTheQuiz);

  let badgeName = '';

  if (type === 'rfQuiz') {
    badgeName = 'dz_recycling_fundamentals';
  }

  if (type === 'mumQuiz') {
    badgeName = 'dz_misunderstood_materials';
  }

  return [badgeName, didPassTheQuiz];
};

export const saveInteraction = ({ type, state }) => {
  const { interactions: prevState = {} } = store.getState();
  if (prevState[type]) {
    dispatch(interactions.saveInteractions({
      [type]: typeof state === 'boolean' ? state : [...new Set([
        ...prevState[type],
        state.toString()
      ])]
    }));
  } else {
    dispatch(interactions.saveInteractions({
      [type]: typeof state === 'boolean' ? state : [...new Set([
        state.toString()
      ])]
    }));
  }
};

export const retrieveInteractions = (interacts) => {
  try {
    const { discovery: discoverData } = store.getState();
    if (interacts) {
      if ('RF' in interacts) {
        const newData = discoverData.recyclingFundamentals;
        for (const rfId of interacts.RF) {
          newData[rfId].done = true;
        }
        dispatch(discovery.updateDiscoveryData(newData));
      }
      if ('MM' in interacts) {
        const newData = discoverData.misundestoodMaterials;
        for (const matId of interacts.MM) {
          newData[matId].done = true;
        }
        dispatch(discovery.updateDiscoveryData(newData));
      }
      if ('LM' in interacts) {
        const lmData = discoverData.learningModules;

        const updateLM = lmData.map((item) => {
          const obj = item;
          for (const matId of interacts.LM) {
            obj[matId].done = true;
          }
          return obj;
        });

        dispatch(discovery.updateDiscoveryData({ ...discoverData, learningModules: updateLM }));
      }
      if ('DID_PASS_RF_QUIZ' in interacts) {
        dispatch(gamification.setPassedRfQuiz(true));
      }
      if ('DID_PASS_LM_QUIZ' in interacts) {
        dispatch(gamification.setPassedLmQuiz(true));
      }
      if ('DID_PASS_MM_QUIZ' in interacts) {
        dispatch(gamification.setPassedMmQuiz(true));
      }
    }
  } catch (E) {
    //
  }
};
